// extracted by mini-css-extract-plugin
export default {"container":"k7HK0dXRJWAS4y70fp14"};